import React from "react";

const mapsApiContext = React.createContext({
  client:"client name", ip:true, language:"en", production:false, libraries:['gemoetry']
});

export default mapsApiContext;